// src/features/cliente/components/ClienteGuard.tsx
// @ts-nocheck
import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";

import { useAuth } from "@/features/sistema/hooks/useAuth";
import { supabase } from "@/features/sistema/services/supabaseClient";

export function ClienteGuard() {
  const { user, loading } = useAuth();
  const { obraId } = useParams();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (loading) return;
    
    // ✅ Se não há usuário, não redireciona (permite logout)
    if (!user) { 
      setChecking(false);
      return; 
    }

    (async () => {
      try {
        const { data: u } = await supabase
          .from("usuarios")
          .select("role")
          .eq("id", user.id)
          .maybeSingle();

        if (u?.role !== "cliente") { 
          setChecking(false); 
          return; 
        }

        const { data: vinc } = await supabase
          .from("obras_clientes")
          .select("obra_id")
          .eq("user_id", user.id)
          .eq("ativo", true)
          .maybeSingle();

        const allowed = vinc?.obra_id;
        if (!allowed) {
          navigate("/sem-acesso", { replace: true });
        } else if (obraId && obraId !== allowed) {
          // Corrige URL errada, mas NÃO fica redirecionando se já está certo
          navigate(`/cliente/obras/${allowed}`, { replace: true });
        } else {
          setChecking(false);
        }
      } catch (error) {
        console.warn('Erro no ClienteGuard:', error);
        setChecking(false);
      }
    })();
  }, [loading, navigate, obraId, user]);

  if (checking) return null;
  return <Outlet />;
}
